import React from 'react';

const AudioOnly = ({...props}) => {

    return (
        <div className="connecting-questions">
            <a href={props.audioLink} target="_blank">
                <button className="yellow-btn">Audio Only</button>
            </a>
        </div>
    );

};


export default AudioOnly;